import React from 'react';

//This is a service class containing functions for session and local storage get, set and clear.
class StorageService extends React.Component {

    //Session Storage
    setSessionStorageItem = (key, value) => {
        try {
            if (value === undefined) {
                sessionStorage.removeItem(key);
                return;
            }
            sessionStorage.setItem(key, JSON.stringify(value));
        }
        catch(err) {
            throw err;
        }
    }

    parseStorageItem = (item) => {
        if (!item || item === 'undefined') {
            return null;
        }
        try {
            return JSON.parse(item);
        } catch {
            return null;
        }
    }

    getSessionStorageItem = (key) => {
        try {
            return this.parseStorageItem(sessionStorage.getItem(key));
        }
        catch(err) {
            throw err;
        }
    }

    getItemFromSessionStorage = (key) => {
        return this.parseStorageItem(sessionStorage.getItem(key));
    }

    clearSessionStorageItems = () => {
        try {
            return sessionStorage.clear();
        }
        catch(err) {
            throw err;
        }
    }

    //Local Storage
    setLocalStorageItem = (key, value) => {
        try {
            if (value === undefined) {
                localStorage.removeItem(key);
                return;
            }
            localStorage.setItem(key, JSON.stringify(value));
        }
        catch(err) {
            throw err;
        }
    }
    
    getLocalStorageItem = (key) => {
        try {
            return this.parseStorageItem(localStorage.getItem(key));
        }
        catch(err) {
            throw err;
        }
    }

    clearLocalStorageItems = () => {
        try {
            return localStorage.clear();
        }
        catch(err) {
            throw err;
        }
    }

}

const storageService = new StorageService();

export default storageService;
// export default connect('','')(storageService);
